import { render, staticRenderFns } from "./PuntoDeVentaDetalle.vue?vue&type=template&id=4a1e632e"
import script from "./PuntoDeVentaDetalle.vue?vue&type=script&lang=js"
export * from "./PuntoDeVentaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports